import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles from './styles'

const DropdownLink = ({ active, href, target, onClick, label, rel }) => (
  <li>
    <a
      href={href}
      target={href ? target : undefined}
      onClick={onClick}
      rel={rel}
      role="presentation"
      tabIndex="0"
      className={cx(styles.link, active && styles.linkActive)}>
      {label}
    </a>
  </li>
)

DropdownLink.propTypes = {
  active: PropTypes.bool,
  href: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  rel: PropTypes.string,
}

export default DropdownLink
